const BASE_URL = 'https://api.rivotex.com/v1/'
const SOCKET_URL = 'https://api.rivotex.com/'

export { BASE_URL, SOCKET_URL }
